import React, { useEffect, useState, Fragment, useRef } from "react";
import "./testResult.scss";
import { useLocation, useNavigate } from "react-router-dom";
import Stepper from "./stepper";
import { Modal } from "react-bootstrap";
import Suggestions from "../../../utils/suggestion";
import { useDispatch, useSelector } from "react-redux";
import {
  getLanguages,
  handleLanguage,
  resetTestDetails,
  getSearchResults,
  getNextSearchResults,
  resetTestLoading,
  getTestList,
  checkOne,
  confirmReplace,
  removeFromSelected,
  resetSelectedTest,
  checkValidTest,
  createCustomTest,
  reorderTest,
  getSelectedTests,
  updateTest,
  resetSearchResult,
  getCodingTestByID,
  resetTestList,
} from "../../../Redux/ActionCreators/testLibraryAction";
import $ from "jquery";
import { getTotal } from "../../../utils/miscelleneous";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import AddTestModal from "../../../utils/addTestModal";
import TestDetailDrawer from "../../../utils/testDetailDrawer";
import { returnErrors } from "../../../Redux/ActionCreators/errorAction";
import { getAccountDetail } from "../../../Redux/ActionCreators/settingAction";
import { getCategory } from "../../../Redux/ActionCreators/gappeoTestAction";

export default function SelectTest() {
  const [isLoading, setIsLoading] = useState(false);
  const [isGuide, setIsGuide] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [testName, setTestName] = useState("");
  const [testNameErr, setTestNameErr] = useState("");
  const [description, setDescription] = useState("");
  const [query, setQuery] = useState("");
  const [rows, setRows] = useState(10);
  const [page, setPage] = useState(1);
  const [level, setLevel] = useState(0);
  const [refId, setRefId] = useState("");
  const [refTypeId, setRefTypeId] = useState("");
  const [loading, setLoading] = useState(false);
  const [openDetail, setOpenDetail] = useState(false);
  const [edit, setEdit] = useState(false);
  const [codingTestId, setCodingTestId] = useState("");
  const [testid, setTestid] = useState("");
  const [coding, setCoding] = useState(false);
  const [testType, setTestType] = useState(0);
  const [langId, setLangId] = useState("");
  const [isConfirm, setIsConfirm] = useState(false);
  const [selectData, setSelectData] = useState("");
  const [newData, setNewData] = useState("");
  const [isFilter, setIsFilter] = useState(false);
  const [lang, setLang] = useState(1);
  const [open, setOpen] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [isFetchingMore, setIsFetchingMore] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [displayRows] = useState(40);

  const timerRef1 = useRef(null);
  const fetchedPagesRef = useRef(new Set());

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const {
    languages,
    suggestions,
    totalCount,
    noFound,
    testLoading,
    tests,
    selectedTests,
    testDetails,
    deleteIds,
    testId,
  } = useSelector((state) => state.testLibrary);
  const { categories } = useSelector((state) => state.gappeoTest);

  const { selectedTenant } = useSelector((state) => state.users);

  const featureFlags =
    selectedTenant?.data?.subscription_plan?.configuration?.feature_flags || {};
  const testTypeFeatureMap = {
    0: "mcq_test",
    1: "coding_test",
    2: "psychometric_test",
    6: "database_test",
    9: "datascience_test",
    10: "language_test",
  };
  const isTestTypeEnabled = (type) => {
    const flagKey = testTypeFeatureMap[type];
    if (!flagKey) return true;
    return featureFlags[flagKey] !== false;
  };

  const normalTests = selectedTests.filter((t) => t.testType !== 10);
  const languageTests = selectedTests.filter((t) => t.testType === 10);
  const orderedTests = [...normalTests, ...languageTests];

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      const message = "Are you sure you want to leave?";
      event.returnValue = message; // Standard for most browsers
      return "Are you sure you want to .map(el => [{ ...el, languageId: 1 }])leave?"; // For some older browsers
    };

    // Add the event listener when the component mounts
    window.addEventListener("beforeunload", handleBeforeUnload);

    // Remove the event listener when the component unmounts
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    const firstRender = async () => {
      setIsLoading(true);

      if (!location.state?.keepTestDetails) {
        dispatch(resetTestDetails());
      }
      dispatch(resetSelectedTest());

      await dispatch(getAccountDetail());
      await dispatch(getCategory());
      await dispatch(getLanguages());
      if (!location.state) {
        navigate("/home");
      }
      if (location.state?.next && location.state.gappeoTest) {
        toggleDrawer(location.state.detail);
        setTestType(0);
        setRefTypeId(1);
        setRefId(0);
      } else if (location.state?.next) {
        localStorage.setItem("testId", "");
        const { detail } = location.state;
        $(".suggestion-container").hide();

        setQuery(detail.referenceName);
        setRefId(detail?.referenceId);
        setRefTypeId(detail?.referenceTypeId);
        setTestType(detail.testType);
        await dispatch(resetTestLoading());
        setPageNumber(1);
        setHasMore(true);
        const refType = detail?.referenceTypeId || 1;
        const refIdValue =
          detail?.testType === 1 || detail?.testType === 6
            ? 1
            : detail?.referenceId || 0;

        const testListRes = await dispatch(
          getTestList(
            level,
            refType,
            refIdValue,
            "",
            1,
            40,
            detail?.testType || 1,
          ),
        );
        if (detail?.referenceTypeId === 1 && testListRes.payload?.[0]) {
          await getCheckedId(
            testListRes.payload[0].testID,
            true,
            { ...testListRes.payload[0], languageId: 1 },
            "test",
          );
        }
        await setIsConfirm(false);
      } else {
        const { testId } = location.state;
        await dispatch(getSelectedTests(testId));
        await dispatch(getTestList(0, 1, 0, "", 1, 40, 0));
      }
      await setIsLoading(false);
    };
    firstRender();
  }, []);

  const changeType = async (code) => {
    // await dispatch(resetTestLoading());
    await dispatch(resetTestList());
    setPageNumber(1);
    setHasMore(true);
    setIsFetchingMore(false);
    fetchedPagesRef.current.clear();

    const selectedTestType = Number(code);
    setTestType(selectedTestType);

    setQuery("");
    setRefId(null);
    setRefTypeId(null);
    setPage(1);

    await dispatch(resetSearchResult());

    let referenceType = 1;
    let referenceId = 0;
    if (selectedTestType === 1 || selectedTestType === 6) {
      referenceType = 1;
      referenceId = 0;
    } else if (selectedTestType === 0) {
      referenceType = 1;
      referenceId = 0;
    } else if (selectedTestType === 9) {
      referenceType = 1;
      referenceId = 0;
    } else if (selectedTestType === 10) {
      referenceType = 1;
      referenceId = 0;
    } else if (selectedTestType === 2) {
      referenceType = 1;
      referenceId = 0;
    } else {
      referenceType = refTypeId || 0;
      referenceId = refId || 0;
    }
    setRefTypeId(referenceType);
    setRefId(referenceId);
    setQuery("");
    if (!isTestTypeEnabled(selectedTestType)) {
      return;
    }
    if (code === 1 || code === 6) {
      await dispatch(
        getTestList(level, referenceType, 0, "", 1, 40, selectedTestType),
      );
    } else {
      await dispatch(
        getTestList(
          level,
          referenceType,
          referenceId,
          "",
          1,
          40,
          selectedTestType,
        ),
      );
    }
  };

  const searchTest = async (val) => {
    clearTimeout(timerRef1.current);
    setQuery(val);
    if (val === "") {
      await dispatch(resetSearchResult());
      await dispatch(resetTestList());

      // 🔒 Reset pagination state
      setPageNumber(1);
      setHasMore(true);
      setIsFetchingMore(false);
      fetchedPagesRef.current.clear();

      // 🔒 IMPORTANT: normalize reference values
      let referenceType = refTypeId || 1;
      let referenceId = 0;

      if (testType === 1 || testType === 6) {
        referenceType = 1;
        referenceId = 1;
      }

      await dispatch(getTestList(level, referenceType, 0, "", 1, 40, testType));
      return;
    }
    setPage(1);
    timerRef1.current = setTimeout(() => delaySearch(val), 800);
  };

  const delaySearch = async (val) => {
    await dispatch(resetSearchResult());
    await dispatch(getSearchResults(val, page, rows));
    $(".suggestion-container").show();
  };

  const fetchData = () => {
    setPage(page + 1);
    dispatch(getNextSearchResults(query, page + 1, rows));
  };

  const goToSelectTest = async (el) => {
    await dispatch(resetTestList());
    setQuery(el.referenceName);
    setRefId(el?.referenceId);
    setRefTypeId(el?.referenceTypeId);
    await dispatch(resetTestLoading());
    setPageNumber(1);
    setHasMore(true);
    await dispatch(
      getTestList(
        level,
        el?.referenceTypeId,
        el?.referenceId,
        "",
        1,
        40,
        testType,
      ),
    );
  };

  const selectLang = async (val) => {
    setLang(Number(val));
    await dispatch(handleLanguage(Number(val)));
  };

  const selectCategory = async (val) => {
    if (!val) {
      setRefId("");
      setRefTypeId(1);

      await dispatch(resetTestLoading());
      setPageNumber(1);
      setHasMore(true);
      await dispatch(getTestList(level, 1, 0, "", 1, 40, testType));
      return;
    }
    const detail = categories.filter((el) => el.categoryId === Number(val))[0];
    if (detail) {
      await setRefId(detail?.categoryId);
      await setRefTypeId(3);
      await dispatch(resetTestLoading());
      setPageNumber(1);
      setHasMore(true);
      await dispatch(
        getTestList(level, 3, detail?.categoryId, "", 1, 40, testType),
      );
    }
    window.innerWidth < 767 && setIsFilter(false);
  };

  const closeSuggestion = () => {
    $(".suggestion-container").fadeOut(200);
  };

  $("body").click((e) => {
    closeSuggestion();
  });

  const getCheckedId = async (val, checked, el, type) => {
    if (!checked) {
      await dispatch(checkOne(val, checked, el, type));
    } else {
      if (selectedTests?.length > 4) {
        returnErrors(dispatch, `You can't select more than 5 tests`, 500);
      } else {
        const found = selectedTests.find((el1) => el1.testID === el.testID);
        setNewData(el);
        if (found) {
          setIsConfirm(true);
          setSelectData(found);
        } else {
          setIsConfirm(false);
          await dispatch(checkOne(val, checked, el, type));
        }
      }
    }
  };

  const removeSkill = async (el) => {
    await dispatch(removeFromSelected(el));
  };

  useEffect(() => {
    const delay = setTimeout(() => {
      validateNameViaApi(testName);
    }, 200);

    return () => clearTimeout(delay);
  }, [testName]);

  useEffect(() => {
    if (tests.length >= totalCount) {
      setHasMore(false);
    }
  }, [tests.length, totalCount]);

  const validateNameViaApi = async (input) => {
    const res = input !== "" && (await dispatch(checkValidTest(input)));
    if (res?.payload?.isValid) {
      setTestNameErr("");
    } else {
      setTestNameErr("Test Name already exist");
    }
  };

  const toggleDrawer = (id) => {
    setCoding(true);
    setLangId(id);
    if (
      location.state.testId ||
      (localStorage.getItem("testId") !== null &&
        localStorage.getItem("testId"))
    ) {
      setOpen(true);
      setEdit(false);
    } else {
      goNext1();
    }
  };

  const goNext = () => {
    if (
      location.state.testId ||
      (localStorage.getItem("testId") !== null &&
        localStorage.getItem("testId"))
    ) {
      goNextWithTest();
    } else {
      setIsOpen(true);
      setCoding(false);
      setTestName("");
      setTestNameErr("");
    }
  };
  const goNext1 = () => {
    if (
      localStorage.getItem("testId") !== null &&
      localStorage.getItem("testId")
    ) {
      goNextWithTest();
    } else {
      setIsOpen(true);
      setTestName("");
      setTestNameErr("");
    }
  };

  const goToQuestion = async () => {
    setLoading(true);
    if (testName.trim("") === "") {
      setTestNameErr("Please Enter Test Name");
      setLoading(false);
    } else {
      let obj = {
        testName: testName,
        testLevel: level,
        tests: orderedTests?.map(
          (el, i) =>
            [
              {
                testId: el.testID,
                levelId: el.testLevel,
                languageId: el.languageId,
                orderId: i + 1,
              },
            ][0],
        ),
        questions: [],
        testDescription: description,
      };
      const res = await dispatch(createCustomTest(obj));
      if (res?.type === "CREATE_CUSTOM_TEST") {
        await setIsOpen(false);
        if (coding) {
          setOpen(true);
          setTestid(res.payload);
          await dispatch(getSelectedTests(res.payload));
        } else {
          navigate(`/home/add-question`, {
            state: { testId: res.payload, isQuestionVisible: false },
          });
        }
        setTestNameErr("");
      }
    }
    setLoading(false);
  };

  const handleDragEnd = async (result) => {
    if (!result.destination) return;
    await dispatch(reorderTest(result));
  };

  const goBack = () => {
    navigate("/home");
  };

  const goNextWithTest = async (shouldNavigate = true) => {
    if (!selectedTests?.length) {
      setTestNameErr("Please select Tests");
      return false;
    }

    setLoading(true);

    // ✅ Safely resolve referenceType and referenceId
    let referenceType = refTypeId || 1;
    let referenceIdValue = refId || 0;

    if (testType === 1 || testType === 6) {
      // For Coding and Database → always send valid defaults
      referenceType = 1;
      referenceIdValue = 1;
    }

    // ✅ Construct payload
    let obj = {
      testId: testid || testId || location.state.testId,
      testName: testDetails?.testName,
      testDescription: testDetails?.testDescription,
      referenceTypeId: referenceType, // ✅ Added
      referenceId: referenceIdValue, // ✅ Added
      tests: orderedTests?.map((el, i) => ({
        testId: el.testID,
        levelId: el.testLevel || el.testLevelId,
        orderId: i + 1,
        testDetailId: el.testDetailId ? el.testDetailId : 0,
        languageId: el.languageId,
      })),
      deletedTestDetailIds: [...new Set(deleteIds)],
      questions: [],
    };

    const res = await dispatch(updateTest(obj));
    if (res?.type === "UPDATE_TEST") {
      await setIsOpen(false);
      if (shouldNavigate) {
        navigate(`/home/add-question`, {
          state: {
            testId: location.state.testId || testId,
            isQuestionVisible: false,
          },
        });
      }
      setTestNameErr("");
      setLoading(false);
      return true;
    }

    setLoading(false);
    return false;
  };

  const editTest = async (el) => {
    await dispatch(getCodingTestByID(el.testID));
    setCodingTestId(el.testID);
    setEdit(true);
    setOpen(true);
  };

  const openFilter = () => {
    setIsFilter(true);
    dispatch(getCategory());
  };

  const fetchNextPage = async () => {
    if (isFetchingMore || !hasMore) return;

    const nextPage = pageNumber + 1;

    let safeRefType = refTypeId || 1;
    let safeRefId = refId || 0;

    if (testType === 1 || testType === 6) {
      safeRefType = 1;
      safeRefId = 1;
    }

    if (isFetchingMore || !hasMore || fetchedPagesRef.current.has(nextPage)) {
      return;
    }
    fetchedPagesRef.current.add(nextPage);
    setIsFetchingMore(true);

    await dispatch(
      getTestList(level, safeRefType, 0, query, nextPage, 40, testType),
    );

    setPageNumber(nextPage);
    setIsFetchingMore(false);
  };

  const SCROLL_THRESHOLD = 200;

  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;

    if (
      scrollTop + clientHeight >= scrollHeight - SCROLL_THRESHOLD &&
      !isFetchingMore &&
      hasMore
    ) {
      fetchNextPage();
    }
  };

  return (
    <div className="gappeo-test-results" style={{ position: "relative" }}>
      {isLoading && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            minHeight: "80vh",
            background: "rgba(255, 255, 255)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <div className="spinner-border" role="status" style={{ color: "#F75891", width: "3rem", height: "3rem" }}>
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}
      <div className="gappeo-test-header">
        <div className="gappeo-test-header-top">
          {testDetails?.testName.length > 0 ? (
            <h4>{testDetails?.testName}</h4>
          ) : (
            <h4>Test Name</h4>
          )}
          <button
            disabled={loading || selectedTests.length === 0}
            onClick={location.state?.next ? goNext : goNextWithTest}
            style={{
              cursor: selectedTests.length === 0 ? "not-allowed" : "pointer",
            }}
          >
            + Create Assessments
          </button>
        </div>

        {
          <Stepper
            type="test"
            goBack={goBack}
            goNext={location.state?.next ? goNext : goNextWithTest}
          />
        }
      </div>

      <div className="gappeo-test-lists">
        <div
          className={
            window.innerWidth > 767
              ? "gappeo-test-data d-flex"
              : "gappeo-test-data"
          }
          style={{ display: isLoading || loading ? "none" : "" }}
        >
          <div className="gappeo-test-data-left">
            {window.innerWidth > 767 ? null : (
              <div className="gappeo-mobile-header">
                <div className="selected-list-header d-flex justify-content-between align-items-end">
                  <div>
                    <h4>Assessment Summary</h4>
                    <h5>
                      {selectedTests?.length} test |{" "}
                      {getTotal(selectedTests, "ques")} Qs |{" "}
                      {getTotal(selectedTests, "duration")} Mins
                    </h5>
                  </div>
                  <button
                    className="outline-btn"
                    onClick={() => setOpenDetail(true)}
                  >
                    VIEW DETAILS
                  </button>
                </div>
              </div>
            )}

            {window.innerWidth > 767 ? (
              <div className="skill-search">
                <div className="skill-tabs">
                  <div>
                    <div
                      className={
                        testType === 0 ? "type-btn active-type" : "type-btn"
                      }
                      onClick={() => changeType(0)}
                    >
                      <img
                        src={
                          testType === 0
                            ? "/images/core-pink.svg"
                            : "/images/core.svg"
                        }
                        width={16}
                        height={16}
                        alt=""
                      />{" "}
                      &nbsp;MCQ
                    </div>
                  </div>
                  <div>
                    <div
                      className={
                        testType === 1 ? "type-btn active-type" : "type-btn"
                      }
                      onClick={() => changeType(1)}
                    >
                      <img
                        src={
                          testType === 1
                            ? "/images/coding-pink.svg"
                            : "/images/coding.svg"
                        }
                        width={16}
                        height={16}
                        alt=""
                      />{" "}
                      &nbsp;Coding
                    </div>
                  </div>
                  <div>
                    <div
                      className={
                        testType === 2 ? "type-btn active-type" : "type-btn"
                      }
                      onClick={() => changeType(2)}
                    >
                      <img
                        src={
                          testType === 2
                            ? "/images/personality-pink.svg"
                            : "/images/personality.svg"
                        }
                        width={16}
                        height={16}
                        alt=""
                      />{" "}
                      &nbsp;Psychometric
                    </div>
                  </div>
                  <div>
                    <div
                      className={
                        testType === 6 ? "type-btn active-type" : "type-btn"
                      }
                      onClick={() => changeType(6)}
                    >
                      <img
                        src={
                          testType === 6
                            ? "/images/database-icon-pink.svg"
                            : "/images/database-icon.svg"
                        }
                        width={20}
                        height={20}
                        alt=""
                      />{" "}
                      &nbsp;Database
                    </div>
                  </div>
                  <div>
                    <div
                      className={
                        testType === 9 ? "type-btn active-type" : "type-btn"
                      }
                      onClick={() => changeType(9)}
                    >
                      <img
                        src={
                          testType === 9
                            ? "/images/data-science-pink.svg"
                            : "/images/data-science.svg"
                        }
                        width={20}
                        height={20}
                        alt=""
                      />{" "}
                      &nbsp;Data Science
                    </div>
                  </div>
                  <div>
                    <div
                      className={
                        testType === 10 ? "type-btn active-type" : "type-btn"
                      }
                      onClick={() => changeType(10)}
                    >
                      <img
                        src={
                          testType === 10
                            ? "/images/languages-world-pink.svg"
                            : "/images/languages-world.svg"
                        }
                        width={20}
                        height={20}
                        alt=""
                      />{" "}
                      &nbsp;Language
                    </div>
                  </div>
                </div>
                <div className="d-flex has-search">
                  <div>
                    <span className="form-control-feedback">
                      <img src="/images/search.svg" alt="" />
                    </span>
                    <input
                      type="search"
                      className="form-control"
                      autoFocus
                      value={query}
                      placeholder="Search for a test / job role / test category"
                      onChange={(e) => searchTest(e.target.value)}
                      style={{ paddingLeft: "2.3rem" }}
                    />
                    {suggestions !== undefined && suggestions.length > 0 ? (
                      <Suggestions
                        type="select-test"
                        suggestions={suggestions}
                        goToSelectTest={goToSelectTest}
                        fetchData={fetchData}
                        noFound={noFound}
                        totalCount={totalCount}
                      />
                    ) : null}
                  </div>
                  <div
                    style={{ marginLeft: window.innerWidth > 767 ? 15 : "" }}
                  >
                    <select
                      className="form-control"
                      value={lang}
                      onChange={(e) => selectLang(e.target.value)}
                    >
                      <option hidden>Select Language</option>
                      {languages?.map((el) => {
                        return (
                          <option value={el.languageId}>
                            {el.languageName}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  <div
                    style={{ marginLeft: window.innerWidth > 767 ? 15 : "" }}
                  >
                    <select
                      className="form-control"
                      value={refId}
                      onChange={(e) => selectCategory(e.target.value)}
                    >
                      <option value="">Select Category</option>
                      {categories?.map((el) => {
                        return (
                          <option value={el.categoryId}>
                            {el.categoryName}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
              </div>
            ) : (
              <div className="skill-search">
                <div
                  className="d-flex align-items-center overflow-auto mb-3"
                  style={{ gap: "8px" }}
                >
                  <div>
                    <div
                      className={
                        testType === 0 ? "type-btn active-type" : "type-btn"
                      }
                      onClick={() => changeType(0)}
                    >
                      <img
                        src="/images/core.svg"
                        width={16}
                        height={16}
                        alt=""
                      />{" "}
                      &nbsp;MCQ
                    </div>
                  </div>
                  <div>
                    <div
                      className={
                        testType === 1 ? "type-btn active-type" : "type-btn"
                      }
                      onClick={() => changeType(1)}
                    >
                      <img
                        src="/images/coding.svg"
                        width={16}
                        height={16}
                        alt=""
                      />{" "}
                      &nbsp;Coding
                    </div>
                  </div>
                  <div>
                    <div
                      className={
                        testType === 2 ? "type-btn active-type" : "type-btn"
                      }
                      onClick={() => changeType(2)}
                    >
                      <img
                        src="/images/personality.svg"
                        width={16}
                        height={16}
                        alt=""
                      />{" "}
                      &nbsp;Psychometric
                    </div>
                  </div>
                  <div>
                    <div
                      className={
                        testType === 6 ? "type-btn active-type" : "type-btn"
                      }
                      onClick={() => changeType(6)}
                    >
                      <img
                        src="/images/database-icon"
                        width={16}
                        height={16}
                        alt=""
                      />{" "}
                      &nbsp;Database
                    </div>
                  </div>
                  <div>
                    <div
                      className={
                        testType === 9 ? "type-btn active-type" : "type-btn"
                      }
                      onClick={() => changeType(9)}
                    >
                      <img
                        src="/images/data-science.svg"
                        width={16}
                        height={16}
                        alt=""
                      />{" "}
                      &nbsp;Data Science
                    </div>
                  </div>
                  <div>
                    <div
                      className={
                        testType === 10 ? "type-btn active-type" : "type-btn"
                      }
                      onClick={() => changeType(10)}
                    >
                      <img
                        src="/images/languages-world-pink.svg"
                        width={20}
                        height={20}
                        alt=""
                      />{" "}
                      &nbsp;Language
                    </div>
                  </div>
                </div>
                <div className="has-search">
                  <span className="form-control-feedback">
                    <img src="/images/search.svg" alt="" />
                  </span>
                  <input
                    type="search"
                    className="form-control"
                    value={query}
                    placeholder="Search for a test / job role / test category"
                    onChange={(e) => searchTest(e.target.value)}
                  />

                  {suggestions !== undefined && suggestions.length > 0 ? (
                    <Suggestions
                      type="select-test"
                      suggestions={suggestions}
                      goToSelectTest={goToSelectTest}
                      fetchData={fetchData}
                      noFound={noFound}
                    />
                  ) : null}
                </div>
                <img
                  src="/images/filter-icon.svg"
                  alt=""
                  onClick={openFilter}
                  className="ms-2"
                />
              </div>
            )}
            {
              <Fragment>
                <div className="select-list">
                  <div
                    className="list-skill"
                    onScroll={
                      isTestTypeEnabled(testType) ? handleScroll : undefined
                    }
                  >
                    {!isTestTypeEnabled(testType) ? (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          height: "100%",
                          width: "100%",
                          padding: "40px 20px",
                          textAlign: "center",
                        }}
                      >
                        <div
                          style={{
                            width: 80,
                            height: 80,
                            borderRadius: "50%",
                            background:
                              "linear-gradient(135deg, #e8f7f8 0%, #c8eced 100%)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginBottom: 20,
                          }}
                        >
                          <svg
                            width="36"
                            height="36"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#f75891"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <rect
                              x="3"
                              y="11"
                              width="18"
                              height="11"
                              rx="2"
                              ry="2"
                            />
                            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                          </svg>
                        </div>
                        <h3
                          style={{
                            color: "#1a1a2e",
                            fontWeight: 700,
                            fontSize: 17,
                            marginBottom: 10,
                          }}
                        >
                          Feature Not Available
                        </h3>
                        <p
                          style={{
                            color: "#6b7280",
                            fontSize: 13,
                            maxWidth: 320,
                            lineHeight: "1.8",
                            marginBottom: 28,
                          }}
                        >
                          This feature is not active with your current plan.
                          <br />
                          Please upgrade to unlock this feature.
                        </p>
                        <button
                          className="save-btn"
                          style={{
                            border: "none",
                            backgroundColor: "#f75891",
                            minWidth: "78px",
                            height: "40px",
                            fontWeight: "bold",
                            fontSize: "14px",
                            lineHeight: "18px",
                            color: "#fff",
                            borderRadius: "4px",
                            padding: "0 12px",
                          }}
                          onClick={() => navigate("/plan")}
                        >
                          Upgrade Plan
                        </button>
                      </div>
                    ) : (
                      <>
                        {testLoading && tests.length === 0 && (
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: "40px 0", color: "#F75891", width:'100%' }}>
                            <div className="spinner-border" role="status">
                              <span className="visually-hidden">Loading...</span>
                            </div>
                          </div>
                        )}
                        {!testLoading &&
                          (testType === 1 || testType === 6 ? (
                            tests?.length > 0 ? (
                              tests?.map((el) => (
                                <div
                                  className="list-skill-item"
                                  key={`${el.testID}-${el.testLevel}`}
                                  onClick={() =>
                                    getCheckedId(el.testID, true, el, "test")
                                  }
                                >
                                  <div>
                                    <img src="/images/plus-circle.svg" alt="" />
                                  </div>
                                  <div className="d-flex flex-column align-items-start ms-3">
                                    <div className="skill-type">
                                      <img
                                        src="/images/coding.svg"
                                        width={12}
                                        alt=""
                                      />
                                      &nbsp;&nbsp;Coding Test
                                    </div>
                                    <h4>{el.testName}</h4>
                                    <p>
                                      {el.questionCount} Qs | {el.duration} Mins
                                      | {el.testLevelName}
                                    </p>
                                  </div>
                                </div>
                              ))
                            ) : (
                              <div
                                className="empty-list"
                                style={{ width: "76%" }}
                              >
                                <img src="/images/magnifier.svg" alt="" />
                                <div className="mt-2">
                                  <h3 style={{ color: "black" }}>
                                    There are no tests in the selected category
                                  </h3>
                                </div>
                              </div>
                            )
                          ) : tests?.length > 0 ? (
                            tests?.map((el) => {
                              return (
                                <div
                                  key={el.testID}
                                  className="list-skill-item"
                                >
                                  <div style={{ width: "100%" }}>
                                    <div
                                      className="d-flex justify-content-between mb-1"
                                      style={{
                                        width:
                                          window.innerWidth > 767 ? "" : "100%",
                                      }}
                                    >
                                      <div className="skill-type">
                                        {el.categoryId === 16 ? (
                                          <img
                                            src="/images/cultural.svg"
                                            alt=""
                                          />
                                        ) : el.categoryId === 17 ? (
                                          <img
                                            src="/images/behavioural.svg"
                                            alt=""
                                          />
                                        ) : el.categoryId === 3 ? (
                                          <img
                                            src="/images/coding.svg"
                                            alt=""
                                            width={16}
                                            height={16}
                                          />
                                        ) : el.categoryId === 18 ? (
                                          <img
                                            src="/images/personality.svg"
                                            alt=""
                                          />
                                        ) : (
                                          <img src="/images/core.svg" alt="" />
                                        )}
                                        &nbsp;&nbsp;{el.categoryName}
                                      </div>
                                      <div>
                                        <input
                                          type="checkbox"
                                          onChange={(e) =>
                                            getCheckedId(
                                              e.target.value,
                                              e.target.checked,
                                              el,
                                              "test",
                                            )
                                          }
                                          style={{ width: 16, height: 16 }}
                                          value={el.testID}
                                          checked={el.isSelected}
                                        />
                                      </div>
                                    </div>
                                    <h4>{el.testName}</h4>
                                    <p>
                                      <strong>{el.testLevelName}</strong> <br />{" "}
                                      {el.questionCount} Qs | {el.duration} Mins
                                      |{" "}
                                      {el.languageId === 1
                                        ? "en"
                                        : el.languageId === 2
                                          ? "es"
                                          : el.languageId === 3
                                            ? "pt"
                                            : el.languageId === 4
                                              ? "pt"
                                              : el.languageId === 8
                                                ? "hi"
                                                : "it"}{" "}
                                    </p>
                                  </div>
                                </div>
                              );
                            })
                          ) : (
                            <div
                              className="empty-list"
                              style={{ width: "76%" }}
                            >
                              <img src="/images/magnifier.svg" alt="" />
                              <div className="mt-2">
                                <h3>
                                  Search for a test / job role / test category
                                </h3>
                              </div>
                            </div>
                          ))}
                        {isFetchingMore && (
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: "20px 0", color: "#F75891" }}>
                            <div className="spinner-border" role="status">
                              <span className="visually-hidden">Loading...</span>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </Fragment>
            }
              <div className="next-btn">
                <button
                  disabled={loading || selectedTests.length === 0}
                  onClick={location.state?.next ? goNext : goNextWithTest}
                  style={{
                    cursor:
                      selectedTests.length === 0 ? "not-allowed" : "pointer",
                  }}
                >
                  NEXT
                </button>
              </div>
          </div>
          <div style={{ width: "25%" }}>
            {window.innerWidth > 767 && (
              <div className="selected-test">
                <div className="selected-list-header">
                  <h4>Assessment Summary</h4>
                  {testDetails?.testName && (
                    <h4
                      className="d-flex justify-content-left align-items-center"
                      style={{ fontSize: 18 }}
                    >
                      {testDetails?.testName}
                    </h4>
                  )}
                  <h5>
                    {selectedTests?.length} test |{" "}
                    {getTotal(selectedTests, "ques")} Qs |{" "}
                    {getTotal(selectedTests, "duration")} Mins
                  </h5>
                  {/* <p>Level:Advanced</p> */}
                </div>
                <div className="selected-list">
                  <h1>Selected Tests</h1>
                  {/* <p>{selectedTests?.length} test | {getTotal(selectedTests, 'ques')} Qs | {getTotal(selectedTests, 'time')} Mins</p> */}
                  <DragDropContext onDragEnd={handleDragEnd}>
                    <Droppable droppableId={"2111"}>
                      {(provided) => (
                        <div
                          {...provided.droppableProps}
                          ref={provided.innerRef}
                        >
                          {selectedTests &&
                            selectedTests?.map((el, index) => {
                              return (
                                <Draggable
                                  key={el.testID}
                                  draggableId={`${el.testID}-${el.testLevel}`}
                                  index={index}
                                >
                                  {(provided) => (
                                    <div
                                      {...provided.draggableProps}
                                      {...provided.dragHandleProps}
                                      ref={provided.innerRef}
                                      className="selected-list-item"
                                    >
                                      <div className="d-flex">
                                        <img
                                          src="/images/drag.svg"
                                          alt=""
                                          width={16}
                                        />
                                        &nbsp;&nbsp;
                                        <div>
                                          <h1>{el.testName}</h1>
                                          <p>
                                            <strong>{el.testLevelName}</strong>{" "}
                                            <br /> {el.questionCount} Qs |{" "}
                                            {el.duration} Mins |{" "}
                                            {el.languageId === 1
                                              ? "en"
                                              : el.languageId === 2
                                                ? "es"
                                                : el.languageId === 3
                                                  ? "pt"
                                                  : el.languageId === 4
                                                    ? "pt"
                                                    : el.languageId === 8
                                                      ? "hi"
                                                      : "it"}
                                          </p>
                                        </div>
                                      </div>
                                      {el.canEdit ? (
                                        <img
                                          src="/images/edit-icon.svg"
                                          onClick={() => editTest(el)}
                                          alt=""
                                          width={16}
                                        />
                                      ) : null}
                                      <img
                                        src="/images/cross-icon.svg"
                                        width={24}
                                        height={24}
                                        onClick={() => removeSkill(el)}
                                        alt=""
                                        title="Delect"
                                      />
                                    </div>
                                  )}
                                </Draggable>
                              );
                            })}
                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                  </DragDropContext>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {window.innerWidth < 767 && (
        <TestDetailDrawer
          openDetail={openDetail}
          setOpenDetail={() => setOpenDetail(false)}
          handleDragEnd={handleDragEnd}
          removeSkill={removeSkill}
          selectedTests={selectedTests}
          testDetails={testDetails}
        />
      )}

      {/* Intro Modal */}
      <Modal
        show={isGuide}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        dialogClassName={"intro-modal"}
      >
        <Modal.Body>
          <div className="sticky-close">
            <img
              src="/images/close-white.svg"
              alt=""
              onClick={() => setIsGuide(false)}
            />
          </div>
          <img src="/images/up-arrow.svg" alt="" />
          <h5>Search for more tests here.</h5>
          <div className="d-flex align-items-center mt-3">
            <h5>Select a test card to addb to the Assessment summary</h5>
            <span className="d-flex ms-3">
              {" "}
              <img src="/images/left-arrow.svg" alt="" /> &nbsp;{" "}
              <img src="/images/left-arrow.svg" alt="" />
            </span>
          </div>
          <div className="ok">
            <button className="outlin-btn" onClick={() => setIsGuide(false)}>
              Ok
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <AddTestModal
        edit={false}
        isOpen={isOpen}
        setIsOpen={() => setIsOpen(false)}
        testName={testName}
        testNameErr={testNameErr}
        description={description}
        setDescription={(val) => setDescription(val)}
        setTestName={(e) => setTestName(e)}
        setTestNameErr={(e) => setTestNameErr(e)}
        goToQuestion={goToQuestion}
        loading={loading}
      />

      {/* <Drawer className='select-drawer' anchor={'top'} open={open} onClose={() => setOpen(!open)}>
                <div className="p-4">
                    {testType === 6 ? (
                    <SelectDatabaseTest goToTest={goToTest} edit={edit} testid={codingTestId} langId={langId} />
                    ) : (
                    <SelectCodingTest goToTest={goToTest} edit={edit} testid={codingTestId} langId={langId} />
                    )}
                </div>
            </Drawer> */}

      {/* ########## Filter modal ############### */}
      <Modal
        show={isFilter}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        dialogClassName={"update-modal"}
      >
        <div class="modal-header" style={{ background: "#f75891" }}>
          <h5 class="modal-title">Select Category</h5>

          <div className="sticky-close" onClick={() => setIsFilter(false)}>
            <img src="/images/close-white.svg" width="15px" alt="" />
          </div>
        </div>
        <Modal.Body style={{ padding: "22px" }}>
          <div>
            <select
              className="form-control"
              disabled={testType === 1 || testType === 2}
              value={refId}
              onChange={(e) => setRefId(e.target.value)}
            >
              <option hidden>Select Category</option>
              {categories?.map((el) => {
                return <option value={el.categoryId}>{el.categoryName}</option>;
              })}
            </select>
          </div>
          <div className="save-btn">
            <button disabled={!refId} onClick={() => selectCategory(refId)}>
              Apply Filter
            </button>
          </div>
        </Modal.Body>
      </Modal>

      {/* ########## Confirm Delete modal ############### */}
      {selectData && (
        <Modal
          show={isConfirm}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          // onHide={this.handleCloseModal}
          dialogClassName={"confirm-modal "}
        >
          <div className="p-4">
            <h1 style={{ lineHeight: "25px" }}>
              You have already added{" "}
              <strong>{selectData?.testLevelName}</strong> level{" "}
              <strong>{selectData?.testName}</strong> test. Do you want to
              replace it with <strong>{newData?.testLevelName}</strong> level
              test?
            </h1>
            <div className="save-btn">
              <button
                onClick={() => {
                  dispatch(confirmReplace(selectData, newData));
                  setIsConfirm(false);
                }}
              >
                Yes
              </button>
              &nbsp;&nbsp;
              <button onClick={() => setIsConfirm(false)}>No</button>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
}
